/* eslint-disable */
import React, { useRef, useEffect } from "react";
import JoditEditor from "jodit-react";

export default function MyEditor({ data = "", IDName}) {
  /* , setContent  */
  const editor = useRef(null);

  const config = {
    height: 400,
    readonly: false,
    toolbarSticky: false,
    uploader: {
      insertImageAsBase64URI: true,
    },
  };

  // ✅ Only set initial value once when mounting
  useEffect(() => {
    if (editor.current) {
      editor.current.value = data || "";
    }
  }, []); // run only once

  return (
     <>
    <JoditEditor
      ref={editor}
      config={config}
      value={data}
      onChange={(newContent) => {
        document.getElementById(IDName).value = newContent;
       /*  console.log("onChange:", newContent);
        setContent(newContent); */
      }}
      onBlur={(newContent) => {
        document.getElementById(IDName).value = newContent;
       /*  console.log("onBlur:", newContent);
        setContent(newContent); */
      }}
    />
     <textarea style={{display:'none'}} id={IDName} defaultValue={data}></textarea>
    </>
  );
}
